import { itemWorkflowTableHeaderHeight } from '@/shared/constants';
/**
 * `nextItemIndex` should already be checked for validity before the function call.
 */
export function scrollItemIntoView(tableScrollingContainerRef, nextItemIndex, keyPressed) {
    // TODO: to delete later
    // Working case with `data-item-index` attribute.
    // const item = scrollingContainerRef.current?.querySelectorAll(`tr[data-item-index="${nextItemIndex}"]`)?.[0] as Element | undefined;
    // What is faster? To have attr (comment above) or to find by nth-child
    const item = tableScrollingContainerRef.current?.querySelector(`tr:nth-child(${nextItemIndex + 1})`);
    const boundingClientRect = item?.getBoundingClientRect();
    const itemTopBound = boundingClientRect?.top ?? 0;
    const itemBottomBound = boundingClientRect?.bottom ?? 0;
    // May be extracted (not necessary to take these values every iteration).
    const scrollingContainerBoundingClientRect = tableScrollingContainerRef.current?.getBoundingClientRect();
    const scrollingContainerTopBound = (scrollingContainerBoundingClientRect?.top ?? 0) + itemWorkflowTableHeaderHeight;
    const scrollingContainerBottomBound = scrollingContainerBoundingClientRect?.bottom ?? 0;
    if ((keyPressed === 'ArrowUp' && itemTopBound < scrollingContainerTopBound) ||
        // Case when `currentItemIndex` is out of visible range (due to tab switch, for example)
        (keyPressed === 'ArrowDown' && itemBottomBound < scrollingContainerTopBound)) {
        // Same as item?.scrollIntoView({ block: 'start', inline: 'nearest' });
        item?.scrollIntoView(true);
    }
    if ((keyPressed === 'ArrowDown' && itemBottomBound > scrollingContainerBottomBound) ||
        // Case when `currentItemIndex` is out of visible range (due to tab switch, for example)
        (keyPressed === 'ArrowUp' && itemTopBound > scrollingContainerBottomBound)) {
        // Same as item?.scrollIntoView({ block: 'end', inline: 'nearest' });
        item?.scrollIntoView(false);
    }
}
